import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { MdPrint } from 'react-icons/lib/md';
import { formatDate } from '../../utils/';

class FactSheetViewForm extends React.Component {
    // static PropTypes = {
    //     factSheet: PropTypes.object.isRequired,
    // }

    constructor(props) {
        super(props);
        this.printBtn = this.printBtn.bind(this);
    }

    printBtn() {
        window.print();
    }

    render() {
        const { factSheet, schedule, members, info } = this.props;

        return (
            <div className="fact-sheet print-fact-sheet">

                <div className="row no-print">
                    <div className="col l2 offset-l10 m2 offset-m10 s2 offset-s10">
                        <button onClick={() => this.printBtn()}>
                            <span><MdPrint size={30} color='#8492a6' /></span>
                        </button>
                        {/* <button className="btn-save float-right no-print" onClick={() => this.printBtn()}>Print</button> */}
                    </div>
                </div> 

                {factSheet.factSheetTitle != null &&  factSheet.factSheetTitle !== ''
                    ? <div className="row print-margin-top--3">
                        <h2 className="text-center">{factSheet.factSheetTitle}</h2>
                    </div>
                    : null}

                {info.fmsids.length > 0
                    ? <div className="row">
                        <div className="col s12">
                            <h4 className="text-center">{info.fmsids.join(', ')}</h4>
                        </div>
                    </div>
                    : null}

                <div className="row">
                    <div className="col l5 m6">
                        {factSheet.clientAgency != null && factSheet.clientAgency !== ''
                            ? <div>
                                <div className="controls padding-bottom-0">
                                    <span className="label underline">Client:</span>
                                </div>
                                <div className="controls padding-top-0">
                                    <span className="label span-inline">City Agency:</span>
                                    <span className="value span-inline">{factSheet.clientAgency}</span>
                                </div>
                            </div>
                            : null}

                        {factSheet.comissioner != null && factSheet.comissioner !== ''
                            ? <div className="controls">
                                <span className="label span-inline">Commissioner:</span>
                                <span className="value span-inline">{factSheet.comissioner}</span>
                            </div>
                            : null}

                        {factSheet.assistantComissioner != null && factSheet.assistantComissioner !== ''
                            ? <div className="controls margin-bottom-15">
                                <span className="label span-inline">Assistant Commissioner:</span>
                                <span className="value span-inline">{factSheet.assistantComissioner}</span>
                            </div>
                            : null}

                        {factSheet.address1 != null && factSheet.address1 !== ''
                            ? <div className="controls margin-bottom-15">
                                <span className="label">Location</span>
                                <span className="value">{factSheet.address1}</span>
                                {factSheet.address2 != null && factSheet.address2 !== ''
                                    ? <span className="value">{factSheet.address2}</span> : null}
                                {factSheet.zipCode != null && factSheet.zipCode !== ''
                                    ? <span className="value">{factSheet.zipCode} </span> : null}
                            </div>
                            : null}

                        {factSheet.lotSize != null && factSheet.lotSize !== ''
                            ? <div className="controls margin-bottom-15">
                                <span className="label">Size</span>
                                <span className="value">Lot Area: {factSheet.lotSize}</span>
                                {factSheet.buildingAreaSize != null && factSheet.buildingAreaSize !== ''
                                    ? <span className="value">New Building Area: {factSheet.buildingAreaSize}</span> : null}
                            </div>
                            : null}

                        {schedule.designStart.actual === null && schedule.designStart.projected === null &&
                            schedule.designCompletion.actual === null && schedule.designCompletion.projected === null &&
                            schedule.constructionStart.actual === null && schedule.constructionStart.projected === null &&
                            schedule.constructionCompletion.actual === null && schedule.constructionCompletion.projected === null
                            ? null :
                            <div className="controls margin-bottom-15">
                                <span className="label">Schedule</span>
                                {schedule.designStart.actual !== null
                                    ? <span className="value">Actual Design Start: {formatDate(schedule.designStart.actual)}</span>
                                    : <span className="value">Projected Design Start: {formatDate(schedule.designStart.projected)}</span>
                                }
                                {schedule.designCompletion.actual !== null
                                    ? <span className="value">Actual Design Completion: {formatDate(schedule.designCompletion.actual)}</span>
                                    : <span className="value">Projected Design Completion: {formatDate(schedule.designCompletion.projected)}</span>
                                }
                                {schedule.constructionStart.actual !== null
                                    ? <span className="value">Actual Construction Start: {formatDate(schedule.constructionStart.actual)}</span>
                                    : <span className="value">Projected Construction Start: {formatDate(schedule.constructionStart.projected)}</span>
                                }
                                {schedule.constructionCompletion.actual !== null
                                    ? <span className="value">Actual Construction Completion: {formatDate(schedule.constructionCompletion.actual)}</span>
                                    : <span className="value">Projected Construction Completion: {formatDate(schedule.constructionCompletion.projected)}</span>
                                }
                            </div>}

                        {factSheet.budgetConstruction != null && factSheet.budgetConstruction !== ''
                            ? <div className="controls">
                                <span className="label span-inline">Budget Construction:</span>
                                <span className="display-inline text-new-roman">$</span>
                                <span className="value span-inline">{factSheet.budgetConstruction.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')}</span>
                            </div>
                            : null}

                        {factSheet.budgetProjectedConstruction != null && factSheet.budgetProjectedConstruction !== ''
                            ? <div className="controls">
                                <span className="label span-inline margin-bottom-15">Projected Construction:</span>
                                <span className="display-inline text-new-roman">$</span>
                                <span className="value span-inline">{factSheet.budgetProjectedConstruction.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')}</span>
                            </div>
                            : null}

                        {factSheet.designConsultant != null && factSheet.designConsultant !== ''
                            ? <div className="controls">
                                <span className="label span-inline">Design Consultants:</span>
                                <span className="value span-inline">{factSheet.designConsultant}</span>
                            </div>
                            : null}

                        {factSheet.constructionMgmt != null && factSheet.constructionMgmt !== ''
                            ? < div className="controls">
                                <span className="label span-inline">Construction Management:</span>
                                <span className="value span-inline">{factSheet.constructionMgmt}</span>
                            </div>
                            : null}
                        {factSheet.contractor != null && factSheet.contractor !== ''
                            ? <div className="controls">
                                <span className="label span-inline">Contractors:</span>
                                <span className="value span-inline">{factSheet.contractor}</span>
                            </div>
                            : null}

                        {members.length > 0
                            ? <div className="controls  margin-bottom-15">
                                <span className="label">DDC Team</span>
                                {members.map(member =>
                                    <span key={member.id} className="value">{member.projectTitle.title}: {member.member.firstName}  {member.member.lastName}</span>
                                )}
                            </div>
                            : null}

                        {factSheet.boroughPresident != null && factSheet.boroughPresident !== ''
                            ? <div className="controls">
                                <span className="label span-inline">Borough President:</span>
                                <span className="value span-inline">{factSheet.boroughPresident}</span>
                            </div>
                            : null}

                        {factSheet.communityBoard != null && factSheet.communityBoard !== ''
                            ? <div className="controls">
                                <span className="label span-inline">Community Board:</span>
                                <span className="value span-inline">{factSheet.communityBoard}</span>
                            </div>
                            : null}

                        {factSheet.councilMember != null && factSheet.councilMember !== ''
                            ? <div className="controls">
                                <span className="label span-inline">Council Member:</span>
                                <span className="value span-inline">{factSheet.councilMember}</span>
                            </div>
                            : null}

                        {factSheet.cityCouncilDistrict != null && factSheet.cityCouncilDistrict !== ''
                            ? <div className="controls">
                                <span className="label span-inline">City Council District:</span>
                                <span className="value span-inline">{factSheet.cityCouncilDistrict}</span>
                            </div>
                            : null}

                        {factSheet.businessImprovementDistrict != null && factSheet.businessImprovementDistrict !== ''
                            ? <div className="controls">
                                <span className="label span-inline">Business Improvement District</span>
                                <span className="value span-inline">{factSheet.businessImprovementDistrict}</span>
                            </div>
                            : null}
                    </div>

                    <div className="col l7 m6">
                        {factSheet.projectDescription != null && factSheet.projectDescription !== ''
                            ? <div className="controls">
                                <span className="label">Project Description</span>
                                <span className="textarea-custom text-new-roman">{factSheet.projectDescription}</span>
                            </div>
                            : null}

                        <br />
                        {factSheet.scopeOfWork != null && factSheet.scopeOfWork !== ''
                            ? <div className="controls">
                                <span className="label">Scope of Work</span>
                               <pre className="textarea-custom text-new-roman"> {factSheet.scopeOfWork} </pre> 
                            </div>
                            : null}

                        <br />
                        <div className="padding-left-2">
                            {_.isEmpty(factSheet.image) ? null: <img src={factSheet.image.base64} alt="fact sheet"/>}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

FactSheetViewForm.propTypes = {
    factSheet: PropTypes.object.isRequired
};

export default (FactSheetViewForm);